import {
  combineReducers,
  createAsyncThunk,
  createSlice
} from "@reduxjs/toolkit";
import { HealthStatus } from "libs/configs/constant";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import HealthInsuranceService from "services/HealthInsuranceService";

let initialState = { list: [], add: {} };

export const getHealthInsuranceList = createAsyncThunk(
  "healthInsurance/getHealthInsuranceList",
  async (body) => {
    const response = await HealthInsuranceService.getHealthInsuranceList(body);
    return response?.results;
  }
);

export const addHealthInsurance = createAsyncThunk(
  "healthInsurance/addHealthInsurance",
  async (body, { dispatch }) => {
    let response;

    response = await Promise.all(
      body.healthInsurance.map((item) =>
        HealthInsuranceService.addHealthInsurance(item)
      )
    );
    const shouldSendDoc = body.healthInsurance
    .filter(c => c.draftId === body.draftId)
    .every(
      (c) => c.Status === HealthStatus.Pending
    );

    if (shouldSendDoc && body.isRHI) {
      response = await HealthInsuranceService.sendHealthInsurance({
        draftId: body.draftId,
      });
    }

    return response?.results;
  }
);

export const healthInsuranceListSlice = createSlice({
  name: "healthInsurance/getHealthInsuranceList",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getHealthInsuranceList, builder, ["list"]);
  },
});

export const healthInsuranceAddSlice = createSlice({
  name: "healthInsurance/addHealthInsurance",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(addHealthInsurance, builder, ["add"]);
  },
});

export const selectListHealthInsurance = (state) => state.healthInsurance.list;
export const selectAddHealthInsurance = (state) => state.healthInsurance.add;

export default combineReducers({
  list: healthInsuranceListSlice.reducer,
  add: healthInsuranceAddSlice.reducer,
});
